import React, {useState} from 'react';
import '../styles/hero.css';
import VideoDialog from "./VideoDialog";

const Hero = () => {
    const [isVideoDialogOpen, setIsVideoDialogOpen] = useState(false);
    const demoVideoUrl = "https://d3peoci61875ob.cloudfront.net/videos/demo.mp4"; // or YouTube/Vimeo embed

    const openVideoDialog = () => {
        setIsVideoDialogOpen(true);
    };

    const closeVideoDialog = () => {
        setIsVideoDialogOpen(false);
    };
    return (
        <>
            <section id="hero" className="hero-section">
                <div className="hero-content">
                    <h1 className="hero-title">
                        <span className="gradient-text">AI-Powered</span> Digital Transformation
                        <br/>That Works While You Sleep
                    </h1>
                    <p className="hero-subtitle">
                        Intellommerce’s <strong className="gradient-text">Intelligent Assistants</strong> don’t just
                        automate your digital transformation; they engineer it. <span></span>
                        From precision-crafted content to data-driven campaign optimization, every element is
                        systematically designed to maximize performance and deliver measurable impact.
                    </p>
                    <div className="hero-cta">
                        <button className="primary-button" onClick={openVideoDialog}>View Demo</button>
                        <button className="secondary-button"
                                onClick={() => document.getElementById('contact').scrollIntoView({behavior: 'smooth'})}>Learn
                            More
                        </button>
                    </div>
                    <div className="hero-stats">
                        <div className="stat">
                            <span className="stat-number">93%</span>
                            <span className="stat-label">Increased Conversion</span>
                        </div>
                        <div className="stat">
                            <span className="stat-number">78%</span>
                            <span className="stat-label">Time Saved</span>
                        </div>
                        <div className="stat">
                            <span className="stat-number">3.5x</span>
                            <span className="stat-label">ROI Improvement</span>
                        </div>
                    </div>
                </div>
                <div className="hero-image">
                    {/* Replace with your actual hero image */}
                    <div className="ai-animation">
                        <div className="pulse-circle"></div>
                        <img src="/assets/images/ai-marketing-dashboard.jpg" alt="AI Marketing Dashboard"/>
                    </div>
                </div>
            </section>

            <VideoDialog
                isOpen={isVideoDialogOpen}
                onClose={closeVideoDialog}
                videoUrl={demoVideoUrl}
            />
        </>
    );
};

export default Hero;